import { loadPreferences } from './collegePreferencesActions'

import * as h2Api from '../h2Api'

export const LIST_PLANS = 'CAP_LIST_PLANS'
export const GET_PLAN = 'CAP_GET_PLAN'
export const UPDATE_PLAN = 'CAP_UPDATE_PLAN'
export const CREATE_PLAN = 'CAP_CREATE_PLAN'
export const DELETE_PLAN = 'CAP_DELETE_PLAN'
export const UPDATE_VIEW = 'CAP_UPDATE_VIEW'
export const SEARCH_OCCUPATIONS = 'CAP_SEARCH_OCCUPATIONS'
export const RELEVANT_OCCUPATIONS = 'CAP_RELEVANT_OCCUPATIONS'
export const RELEVANT_BUDGETS = 'CAP_RELEVANT_BUDGETS'
export const RELEVANT_PROGRAMS = 'CAP_RELEVANT_PROGRAMS'
export const RELEVANT_INSTITUTIONS = 'CAP_RELEVANT_INSTITUTIONS'
export const PREFERENCES_MODAL = 'CAP_PREFERENCES_MODAL'

export const listPlans = () => {
  return h2Api.get('/cap/list')({ type: LIST_PLANS })
}

export const getPlan = planId => {
  return h2Api.get(`/cap/${planId}`)({ type: GET_PLAN })
}

export const updatePlan = plan => {
  return h2Api.post(`/cap/${plan.id}`, plan)({ type: UPDATE_PLAN })
}

export const createPlan = planInfo => {
  return h2Api.put('/cap', planInfo)({ type: CREATE_PLAN })
}

export const deletePlan = planId => {
  return h2Api.doDelete(`/cap/${planId}`)({ type: DELETE_PLAN })
}

export const updateView = contents => dispatch => {
  return dispatch({ type: UPDATE_VIEW, contents })
}

export const searchOccupations = query => {
  return h2Api.post('/cap/occupations/search', { query })({ type: SEARCH_OCCUPATIONS })
}

export const relevantOccupations = plan => {
  return h2Api.post('/cap/occupations/relevant', plan)({ type: RELEVANT_OCCUPATIONS })
}

export const relevantBudgets = plan => {
  return h2Api.post('/cap/budget/relevant', plan)({ type: RELEVANT_BUDGETS })
}

export const relevantPrograms = plan => {
  return h2Api.post('/cap/programs/relevant', plan)({ type: RELEVANT_PROGRAMS })
}

export const relevantInstitutions = plan => {
  return h2Api.post('/cap/institutions/relevant', plan)({ type: RELEVANT_INSTITUTIONS })
}

export const gotoStep = (selectedPlan, step) => dispatch => {
  switch (step) {
    case '1': {
      return dispatch(relevantOccupations(selectedPlan)).then(() => {
        dispatch(updateView({ step }))
      })
    }
    case '2': {
      return dispatch(relevantBudgets(selectedPlan)).then(() => {
        dispatch(updateView({ step }))
      })
    }
    case '3': {
      return dispatch(relevantPrograms(selectedPlan)).then(() => {
        dispatch(updateView({ step }))
      })
    }
    case '4': {
      return dispatch(relevantInstitutions(selectedPlan)).then(() => {
        dispatch(updateView({ step }))
      })
    }
    default: {
      dispatch(updateView({ step }))
    }
  }
}

export const togglePreferencesModal = isOpen => dispatch => {
  if (isOpen) {
    dispatch(loadPreferences()).then(() => {
      dispatch({ type: PREFERENCES_MODAL, isOpen: true })
    })
  } else {
    dispatch({ type: PREFERENCES_MODAL, isOpen: false })
  }
}
